import {
  FETCH_CONNECTION,
  FETCH_CONNECTION_FAILURE,
  FETCH_CONNECTION_SUCCESS,
  SET_SORTER,
  SET_WAY,
  FETCH_DETAIL,
  FETCH_DETAIL_FAILURE,
  FETCH_DETAIL_SUCCESS,
  SET_OPENED_CONNECTION_DETAIL,
  FETCH_NEXT_CONNECTIONS,
  FETCH_NEXT_CONNECTION_FAILURE,
  FETCH_NEXT_CONNECTION_SUCCESS,
  FETCH_PREV_CONNECTIONS,
  FETCH_PREV_CONNECTION_FAILURE,
  FETCH_PREV_CONNECTION_SUCCESS,
} from './constants';

import { __, getProp } from '../../utilities';

const connectionInitialState = {
  byId: {},
  data: [],
  sorter: {
    label: __('Zobraziť podľa ceny'),
    value: 'price',
  },
  way: null,
  error: null,
  isFetching: false,
  nextWay1: null,
  prevWay1: null,
  nextWay2: null,
  prevWay2: null,
  isFetchingNext: false,
  isFetchingPrev: false,
};

const connectionReducer = (state = connectionInitialState, action) => {
  switch (action.type) {
    case FETCH_CONNECTION:
      return { ...state, isFetching: true };
    case FETCH_PREV_CONNECTION_SUCCESS:
      return {
        ...state,
        isFetchingPrev: false,
        byId: {
          ...action.payload.connections.reduce((prev, next) => {
            return { ...prev, [next.id_connect]: next };
          }, {}),
          ...state.byId,
        },
        data: [
          ...action.payload.connections.reduce((prev, next) => {
            if (state.data.indexOf(next.id_connect) === -1) {
              return [...prev, next.id_connect];
            }
            return [...prev];
          }, []),
          ...state.data,
        ],
        prevWay1: action.payload.prevFirstWay,
        prevWay2: action.payload.prevSecondWay,
        error: null,
      };
    case FETCH_PREV_CONNECTIONS:
      return {
        ...state,
        isFetchingPrev: true,
      };
    case FETCH_PREV_CONNECTION_FAILURE:
      return {
        ...state,
        isFetchingPrev: true,
      };
    case FETCH_NEXT_CONNECTION_SUCCESS:
      return {
        ...state,
        isFetchingNext: false,
        byId: {
          ...state.byId,
          ...action.payload.connections.reduce((prev, next) => {
            return { ...prev, [next.id_connect]: next };
          }, {}),
        },
        data: [
          ...state.data,
          ...action.payload.connections.reduce((prev, next) => {
            if (state.data.indexOf(next.id_connect) === -1) {
              return [...prev, next.id_connect];
            }
            return [...prev];
          }, []),
        ],
        nextWay1: action.payload.nextFirstWay,
        nextWay2: action.payload.nextSecondWay,
        error: null,
      };
    case FETCH_NEXT_CONNECTIONS:
      return {
        ...state,
        isFetchingNext: true,
      };
    case FETCH_NEXT_CONNECTION_FAILURE:
      return {
        ...state,
        isFetchingNext: true,
      };
    case FETCH_CONNECTION_SUCCESS:
      return {
        ...state,
        byId: {
          ...action.payload.connections.reduce((prev, next) => {
            return { ...prev, [next.id_connect]: next };
          }, {}),
          ...state.byId,
        },
        data: [
          ...action.payload.connections.reduce((prev, next) => {
            return [...prev, next.id_connect];
          }, []),
        ],
        nextWay1: action.payload.nextFirstWay,
        prevWay1: action.payload.prevFirstWay,
        nextWay2: action.payload.nextSecondWay,
        prevWay2: action.payload.prevSecondWay,
        error: null,
        isFetching: false,
      };
    case FETCH_CONNECTION_FAILURE:
      return {
        ...state,
        error: action.payload,
        isFetching: false,
      };
    case SET_SORTER:
      return {
        ...state,
        sorter: action.payload,
      };
    case SET_WAY:
      return {
        ...state,
        way: action.payload,
      };
    default:
      return state;
  }
};

export default connectionReducer;

const connectionDetailInitialState = {
  connectionsById: {},
  selectedConnection: null,
  error: null,
  isFetching: false,
};

export const connectionDetailReducer = (
  state = connectionDetailInitialState,
  action,
) => {
  switch (action.type) {
    case FETCH_DETAIL:
      return { ...state, isFetching: true };
    case FETCH_DETAIL_SUCCESS:
      return {
        ...state,
        connectionsById: {
          ...state.connectionsById,
          [action.connectionId]: {
            sectorsById: {
              ...getProp(state, [
                'connectionsById',
                action.connectionId,
                'sectorsById',
              ]),
              [action.id]: { ...action.payload },
            },
          },
        },
        error: null,
        isFetching: false,
      };
    case FETCH_DETAIL_FAILURE:
      return {
        ...state,
        error: action.payload,
        isFetching: false,
      };
    case SET_OPENED_CONNECTION_DETAIL:
      return {
        ...state,
        selectedConnection: action.payload,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/containers/Connections/reducer.js